import type { TFunction } from 'i18next'

/**
 * Resolve an i18n key expected to hold an array of strings, defensively.
 *
 * `t(key, { returnObjects: true })` returns the *key string* (not an array) when
 * a key is missing or misconfigured. Mapping over that string would crash the
 * render — and under the puppeteer prerender a crashed route degrades to the
 * timeout snapshot. This guard returns `[]` instead, so a future copy typo
 * yields an empty section rather than broken SEO HTML.
 */
export function arrayKey(t: TFunction, key: string): readonly string[] {
  const value = t(key, { returnObjects: true })
  return Array.isArray(value) ? (value as string[]) : []
}

/** Same guard for keys holding an array of objects (e.g. comparison rows). */
export function objectArrayKey<T>(t: TFunction, key: string): readonly T[] {
  const value = t(key, { returnObjects: true })
  return Array.isArray(value) ? (value as T[]) : []
}
